import React from 'react'
import './trainers.css'

const Trainers = () => {
  return (
    <div>Trainers</div>
  )
}

export default Trainers